// extracted by mini-css-extract-plugin
export default {"root":"FullPageLoader_root__-psIC"};